import type { IWaiverFilters } from "@/apps/engagement-letter-database/data/types";

import type { HomeWaiverRow } from "../../../../constants";

export function matchesWaiverFilters(row: HomeWaiverRow, filters: IWaiverFilters): boolean {
  const checks: boolean[] = [];

  if (filters.searchText) {
    const term = filters.searchText.toLowerCase();
    const haystack = [
      row.clientName,
      row.matterNumber,
      row.clientNumber,
      row.adverseClientName,
      row.adverseContactSigner,
      row.adverseAttorney,
      row.clientContact,
      row.clientAttorney,
    ]
      .join(' ')
      .toLowerCase();
    checks.push(haystack.includes(term));
  }
  if (filters.clientName) {
    checks.push(row.clientName.toLowerCase().includes(filters.clientName.toLowerCase()));
  }
  if (filters.clientNumber) {
    checks.push(row.clientNumber.toLowerCase().includes(filters.clientNumber.toLowerCase()));
  }
  if (filters.adverseClientName) {
    checks.push(row.adverseClientName.toLowerCase().includes(filters.adverseClientName.toLowerCase()));
  }
  if (filters.matterNumber) {
    checks.push(row.matterNumber.toLowerCase().includes(filters.matterNumber.toLowerCase()));
  }
  if (filters.adverseAttorney) {
    checks.push(row.adverseAttorney.toLowerCase().includes(filters.adverseAttorney.toLowerCase()));
  }
  if (filters.multipleWaivers === 'yes') checks.push(row.multipleWaivers === 'Yes');
  else if (filters.multipleWaivers === 'no') checks.push(row.multipleWaivers !== 'Yes');

  if (checks.length === 0) return true;

  return filters.logicOperator === 'OR' ? checks.some(Boolean) : checks.every(Boolean);
}